"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformVehiclesToAssignationToolDriverVehicles = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const transformVehiclesToAssignationToolDriverVehicles = (vehicles, vehicleModels) => vehicles.map((vehicle) => {
    const model = vehicleModels.find((currentModel) => currentModel._id === vehicle.modelId);
    return {
        _id: vehicle._id,
        title: `${model.name} ${vehicle.manufactureYear}`,
        seatsCount: model.seatsCount,
        color: vehicle.color,
        ownerUserId: vehicle.ownerUserId,
        isLuxury: model.isLuxury,
        type: ((m) => {
            switch (m.seatsCount) {
                case 2:
                case 3:
                    return legacy_enums_1.VehicleType.Sedan;
                case 4:
                    return legacy_enums_1.VehicleType.Mpv;
                case 5:
                case 6:
                case 7:
                    return legacy_enums_1.VehicleType.Van;
                case 8:
                case 9:
                case 10:
                    return legacy_enums_1.VehicleType.Shuttle;
                default:
                    return legacy_enums_1.VehicleType.Sedan;
            }
        })(model),
        licencePlate: vehicle.licensePlate,
        status: 1,
        approvedForCountryIds: model.approvedForCountryIds,
        luxuryForCountryIds: model.luxuryForCountryIds,
    };
});
exports.transformVehiclesToAssignationToolDriverVehicles = transformVehiclesToAssignationToolDriverVehicles;
//# sourceMappingURL=transformVehiclesToAssignationToolDriverVehicles.js.map